module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), (!_vm.imagem) ? _c('div', [_c('input', {
    attrs: {
      "type": "file",
      "accept": _vm.accept
    },
    on: {
      "change": _vm.onFileChange
    }
  })]) : _c('div', [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.imagem
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.removeImage
    }
  }, [_c('i', {
    staticClass: "far fa-trash-alt"
  }), _vm._v(" Remover")])])]), _vm._v(" "), (_vm.urlArquivo != '') ? _c('div', {
    staticClass: "col-sm-6 text-center"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.label) + " Atual")]), _vm._v(" "), (_vm.tipo == 'pdf') ? _c('span', [_c('a', {
    attrs: {
      "href": _vm.urlArquivo,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.arquivo.key))])]) : _c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.urlArquivo
    }
  })]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-599cc78d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Input/FileImage.vue
// module id = 870
// module chunks = 1